import {Promo} from './promo';
import {Option} from './option';

export class PromoUtil {
  private static readonly _maximumDuration = 999;
  private static readonly _monthlyLabel = 'promo-duration';
  private static readonly _permanentLabel = 'promo-permanent';

  public static getPermanentOrLessThanAMonthDiscount(option: Option): number {
    return option.promos.filter(promo => PromoUtil.isPermanentOrLessThanAMonthPromo(promo))
      .map(promo => promo.price)
      .reduce((curr, prev) => curr + prev, 0);
  }

  public static getMonthlyDiscount(option: Option): number {
    return option.promos.filter(promo => PromoUtil.isMonthlyPromo(promo))
      .map(promo => promo.price)
      .reduce((curr, prev) => curr + prev, 0);
  }

  public static getMonthlyDiscountForSoho(option: Option): number {
    return option.promos.filter(promo => PromoUtil.isMonthlyPromo(promo))
      .map(promo => promo.priceexclvat)
      .reduce((curr, prev) => curr + prev, 0);
  }

  public static getPromoLabel(option: Option): string {
    if (option.promos.some(promo => PromoUtil.isMonthlyPromo(promo))) {
      return PromoUtil._monthlyLabel;
    }

    if (option.promos.some(promo => PromoUtil.isPermanentOrLessThanAMonthPromo(promo))) {
      return PromoUtil._permanentLabel;
    }

    return undefined;
  }

  private static isPermanentOrLessThanAMonthPromo(promo: Promo): boolean {
    return promo.duration === 0 && promo.price < 0;
  }

  private static isMonthlyPromo(promo: Promo): boolean {
    return promo.duration > 0 && promo.price < 0;
  }

  public static getShortestPromoDuration(option: Option): number {
    const duration = option.promos.filter(promo => PromoUtil.isMonthlyPromo(promo))
      .map(promo => promo.duration)
      .reduce((a, b) => Math.min(a, b), PromoUtil._maximumDuration);
    return duration === PromoUtil._maximumDuration ? 0 : duration;
  }
}
